import axios from "axios";
import constants from "../shared/constants";

const spotifyToken = axios.create({
  baseURL: constants.spotifyTokenURL,
});

export default spotifyToken;
